import { Helmet } from 'react-helmet';
import pageStyles from '../styles/page-common.module.css';

function SupportUs() {
  return (
    <>
      <Helmet>
        <title>Support LingoLeaf | LingoLeaf</title>
        <meta name="description" content="Support LingoLeaf by contributing to our mission of making language learning accessible to all." />
      </Helmet>
      <div className={pageStyles.styledPageLeftAligned}>
        <h1>Support LingoLeaf</h1>
        <p>
          LingoLeaf is maintained and run by just two people. When LingoLeaf was launched, we launched as a paid platform. However, we switched to a free platform in August 2025, in order to help make language learning accessible to everyone.
        </p>
        <p>
          However, LingoLeaf takes a lot of work to maintain, and incurs various costs including hosting and content creation. The two of us perform all this work in our spare time, and bear these costs ourselves. If you find LingoLeaf useful and would like to support us, we would be very grateful for any donations you can make. We've set up a page on 'Buy Me a Coffee' where you can make a one-off or recurring donation of any amount. You can also support us by sharing LingoLeaf with your friends and family. The button below will take you to our Buy Me a Coffee page.
        </p>
        <br/>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <a href="https://buymeacoffee.com/lingoleaf" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button>Support LingoLeaf</button>
          </a>
        </div>
      </div>
    </>
  );
}

export default SupportUs;